import { render } from "./monitorVedio.vue?vue&type=template&id=0631f008&scoped=true"
import script from "./monitorVedio.vue?vue&type=script&lang=js"
export * from "./monitorVedio.vue?vue&type=script&lang=js"

import "./monitorVedio.vue?vue&type=style&index=0&id=0631f008&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0631f008"]])

export default __exports__